"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectAbortableError = exports.isPromiseAbortError = void 0;
var promiseAbortErrorName = 'PromiseAbortError';
function isPromiseAbortError(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === promiseAbortErrorName;
}
exports.isPromiseAbortError = isPromiseAbortError;
var RejectAbortableError = /** @class */ (function (_super) {
    __extends(RejectAbortableError, _super);
    function RejectAbortableError(message) {
        var _this = _super.call(this, message) || this;
        _this.isAborted = true;
        return _this;
    }
    return RejectAbortableError;
}(Error));
exports.RejectAbortableError = RejectAbortableError;
function makeAbortable(promise, onAbort) {
    if (onAbort === void 0) { onAbort = function () {
    }; }
    var hasPromiseAborted = false;
    var errorMessage = 'An abortable promise was aborted.';
    var wrappedPromise = new Promise((function (resolve, reject) {
        promise
            .then(function (value) {
            if (hasPromiseAborted) {
                reject(new RejectAbortableError(errorMessage));
            }
            else {
                resolve(value);
            }
        })
            .catch(function (error) {
            // error has already aborted   error or promise hasn't aborted
            if ((error && error.isAborted) || !hasPromiseAborted) {
                reject(error);
            }
            else {
                reject(new RejectAbortableError(errorMessage));
            }
        });
    }));
    // @ts-ignore
    wrappedPromise.abort = wrappedPromise.abort || (function () {
        onAbort();
        hasPromiseAborted = true;
    });
    return wrappedPromise;
}
exports.default = makeAbortable;
//# sourceMappingURL=makeAbortable.js.map